import React, { useMemo } from 'react';

const W = 212;
const H = 96;
const PAD_X = 20;
const PAD_Y = 18;
const CHART_W = W - PAD_X * 2;
const CHART_H = H - PAD_Y * 2;
const BAR_GAP = 10;

const OPTION_COLORS = ['#4ade80', '#22d3ee', '#fbbf24', '#f87171'];
const OPTION_LABELS = ['A', 'B', 'C', 'D'];

// Grafische Uebersicht, wie sich die richtigen Antworten (A/B/C/D) der
// aktiven Show verteilen. Dient als Balance-Kontrolle, damit die Loesung
// nicht immer bei derselben Option liegt.
function AnswerDistributionChart({ questions = [] }) {
    const counts = useMemo(() => {
        const c = [0, 0, 0, 0];
        questions.forEach((q) => {
            const idx = Number(q.richtigeAntwort);
            if (idx >= 0 && idx <= 3) c[idx]++;
        });
        return c;
    }, [questions]);

    const total = counts.reduce((s, v) => s + v, 0);
    const maxCount = Math.max(...counts, 1);
    const barWidth = (CHART_W - BAR_GAP * 3) / 4;

    return (
        <div>
            <svg
                width={W}
                height={H}
                viewBox={`0 0 ${W} ${H}`}
                style={{ display: 'block', overflow: 'visible' }}
            >
                {counts.map((count, i) => {
                    const barHeight = (count / maxCount) * CHART_H;
                    const x = PAD_X + i * (barWidth + BAR_GAP);
                    const y = PAD_Y + CHART_H - barHeight;
                    return (
                        <g key={i}>
                            <rect
                                x={x}
                                y={y}
                                width={barWidth}
                                height={barHeight}
                                rx={3}
                                fill={OPTION_COLORS[i]}
                                opacity={0.85}
                            />
                            <text
                                x={x + barWidth / 2}
                                y={y - 6}
                                textAnchor="middle"
                                fontSize="11"
                                fontWeight="700"
                                fill={OPTION_COLORS[i]}
                            >
                                {count}
                            </text>
                            <text
                                x={x + barWidth / 2}
                                y={PAD_Y + CHART_H + 13}
                                textAnchor="middle"
                                fontSize="10"
                                fill="#8aa3d4"
                            >
                                {OPTION_LABELS[i]}
                            </text>
                        </g>
                    );
                })}
            </svg>

            <div style={{
                textAlign: 'center',
                fontSize: '11px',
                color: '#8aa3d4',
                marginTop: '4px',
            }}>
                {total} Frage{total !== 1 ? 'n' : ''}
            </div>
        </div>
    );
}

export default AnswerDistributionChart;
